import React, { PureComponent } from 'react'
import { pageData } from 'decorators'
import { connect } from 'react-redux'
import PhaseActions from 'store/redux/phase'
import { SectionIntro, SectionSelectors, SectionAllCards, SubSectionPreSeasonCardsGroup, SectionPreSeasonPanels } from 'components'
import PHASE from 'utils/constants/phases'
import DATA_SELECTORS from 'data/selectors'
import { translate } from 'react-i18next'
import { find } from 'lodash'
import { Phase } from '../Phase'

@pageData({ title: 'PreSeason' })
@connect(
    state => ({
        phase: state.phaseInfo.phase,
        credits: state.phase.credits,
        selection: state.phase.selection,
        preSeasonData: state.phaseInfo.data,
        curvesParams: state.phaseInfo.performanceOverDeteriorationCurveParams,
        isAMToolAvailable: state.phaseInfo.AMTool,
        isAMToolActive: state.phase.isAMToolActive,
        season: state.phaseInfo.season
    }),
    {
        setCredits: PhaseActions.setCredits,
        updateSelection: PhaseActions.updatePreSeasonSelection
    }
)
@translate()
export class PreSeason extends PureComponent {
    state = {
        selectedSelectorId: null //'pre-season-engine'
    }

    componentWillMount() {
        const { t } = this.props
        this.selectors = DATA_SELECTORS[PHASE.PRE_SEASON].map(s => ({ ...s, label: t('game.PRE_SEASON.selectorLabel', { name: s.name }) }))
        this.refreshPhaseData(this.props)
    }
    componentWillUpdate(nextProps, nextState) {
        if (nextProps.phase === PHASE.PRE_SEASON) {
            if (nextProps.preSeasonData !== this.props.preSeasonData) {
                this.refreshPhaseData(nextProps)
            }
        }
    }

    setPhaseRef = ref => {
        this.phaseRef = ref
    }

    refreshPhaseData = props => {
        const { phase, preSeasonData, selection } = props

        if (phase === PHASE.PRE_SEASON) {
            // if there's something selected, we set selectedSelectorId
            this.setState({ selectedSelectorId: (find(this.selectors, ({ id }) => !!(selection[id] || {}).type) || {}).id || null })
            // if there's something selected, we update the icons for each selection
            this.selectors = this.selectors.map(({ id, icon, ...selector }) => {
                const selectedOptionType = (selection[id] || {}).type
                const selectedOption = selectedOptionType ? find(preSeasonData[id].options, o => o.id === selectedOptionType) : undefined
                return {
                    id,
                    icon: selectedOption ? selectedOption.icon : icon,
                    ...selector,
                }
            })
            // updates the data
            this.selectorsIds = this.selectors.map(({ id }) => id)
            this.cardsData = this.selectors.map(({ id }) => ({
                groupId: id,
                cards: preSeasonData[id].options.map(o => ({ ...o, typeId: o.id }))
            }))
        }
    }

    handleSelectSelector = id => {
        this.setState({ selectedSelectorId: id })
    }
    handleSelectCard = (groupId, typeId, icon) => {
        const { updateSelection } = this.props
        // console.log(`selectCard: ${groupId} - ${typeId}`)
        updateSelection(groupId, typeId)
        this.selectors = this.selectors.map(selector => {
            if (selector.id === groupId) return { ...selector, icon }
            return selector
        })
    }
    handleSelectCardUnits = selectionData => {
        const { credits, setCredits, updateSelection } = this.props
        const { error, groupId, typeId, currentUnits, nextUnits, currentTotalPrice, nextTotalPrice, deltaTotalPrice } = selectionData
        // console.log('setCardUnits: ', selectionData)
        if (error) {
            this.phaseRef.showModalErrorInfo(error)
        } else {
            setCredits(credits + deltaTotalPrice)
            updateSelection(groupId, typeId, nextUnits)
        }
    }

    renderCardsGroup = ({ groupId, cards }) => {
        const { credits, selection } = this.props
        return (
            <SubSectionPreSeasonCardsGroup
                key={groupId}
                groupId={groupId}
                cards={cards}
                availableCredits={credits}
                selection={selection[groupId]}
                onSelect={this.handleSelectCard}
                onSelectUnits={this.handleSelectCardUnits}
            />
        )
    }
    render() {
        const { phase, season, preSeasonData, selection, curvesParams, isAMToolAvailable, isAMToolActive, t } = this.props
        const { selectedSelectorId } = this.state
        const anyIsSeleted = !!selectedSelectorId

        return (
            phase === PHASE.PRE_SEASON && (
                <Phase
                    className="PreSeason"
                    phaseRef={this.setPhaseRef}
                    showEndPhaseBtn={anyIsSeleted}
                    interTitles={[{ title: t('game.PRE_SEASON.interTitle.title', { season }) }]}
                >
                    <SectionIntro show={!anyIsSeleted} text={t('game.PRE_SEASON.intro')} />
                    <SectionPreSeasonPanels
                        data={preSeasonData}
                        selectedGroupId={selectedSelectorId}
                        selection={selection}
                        curvesParams={curvesParams}
                        isAMToolAvailable={isAMToolAvailable}
                        isAMToolActive={isAMToolActive}
                    />
                    <SectionAllCards groupIds={this.selectorsIds} selectedGroupId={selectedSelectorId}>
                        {this.cardsData.map(this.renderCardsGroup)}
                    </SectionAllCards>
                    <SectionSelectors selectors={this.selectors} selected={selectedSelectorId} onSelect={this.handleSelectSelector} />
                </Phase>
            )
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/PreSeason/PreSeason.js